import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleRectangleNone extends AbstractPreset {
	getName(): string {
		return 'rectangleRectangleNone';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "none"
			},
			"cutouts": [
				{
					"type": "shape",
					"shape": "rectangle",
					"primitives": {
						"width": 25,
						"length": 15
					},
					"modifiers": [],
					"position": {
						"left": 150,
						"bottom": 250,
						"rotation": 0
					}
				}
			],
		};
	}
}
